const AuthChallenge = Object.freeze({
  NewPasswordRequired: 'NEW_PASSWORD_REQUIRED',
});

export default AuthChallenge;
